var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAxoLogoWhiteTextTransparentBackground = function SvgAxoLogoWhiteTextTransparentBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 24,
    fill: "none",
    viewBox: "0 0 44 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 23.197h3.64L7.276.803H3.64zM10.917.803h-3.64l3.64 22.394h3.639z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.375.803h3.64L21.653 12l-3.64 11.197h-3.639L18.015 12zm10.917 0h3.639L25.29 12l3.64 11.197h-3.64L21.653 12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.884 12c0-8.425 2.1-11.645 7.558-11.645S44 3.575 44 12s-2.1 11.645-7.558 11.645-7.558-3.22-7.558-11.645m7.558 8.174c2.883 0 3.835-2.044 3.835-8.174s-.952-8.174-3.835-8.174S32.607 5.87 32.607 12s.952 8.174 3.835 8.174"
  })));
};
export default SvgAxoLogoWhiteTextTransparentBackground;